'use strict';
const PollerImpl = require('./poller'),
	TaskImpl = require('./task'),
	taskIdGeneratorImpl = require('@mindmup/js-utils/src/unique-string'),
	s3SignatureValid = require('./s3-signature-valid');
	// taskIdGenerator = require('@mindmup/js-utils/src/unique-string');
module.exports = function TaskBuilder(goldApi, s3Api, intervalController, licenseRetriever, optional) {
	if (!goldApi || !s3Api || !intervalController || !licenseRetriever) {
		throw new Error('invalid-args');
	}
	const self = this,
		Poller = (optional && optional.Poller) || PollerImpl,
		Task = (optional && optional.Task) || TaskImpl,
		taskIdGenerator = (optional && optional.taskIdGenerator) || taskIdGeneratorImpl;
	self.newTaskId = taskIdGenerator;
	self.build = async (taskId) => {
		if (!taskId) {
			throw new Error('invalid-args');
		}
		const poller = new Poller(intervalController),
			checkForLicense = async () => {
				const license = await licenseRetriever();
				if (!license) {
					throw 'not-authenticated';
				}
				return true;
			};

		await checkForLicense();
		return new Task(taskId, poller, licenseRetriever, goldApi, s3Api, s3SignatureValid);
	};
};
